const InputError = (props: any) => {
  return (
    <div className="text-error text-body-sm mt-1">
      {props.children ? props.children : ""}
    </div>
  );
};

export default InputError;
